const [w,d,l] = [window,document,location]
const mq_small_up = matchMedia('(min-width:768px)').matches
const mq_small_down = matchMedia('(max-width:767px)').matches

export default function ANCHORLINK (){
  
    // アンカーリンクスクロール設定
    $(d).on('click','a[href^="#"]:not([href^="#/"]),a[href*="#"]:not([href^="#/"]):not([data-plugin="openwindow"])',function(e){
      var path = $(this).attr('href').match(/^([^#]+)(#.*)?/)||[];
      if( path[1] === l.pathname + l.search ){
        e.preventDefault();
        $(this).attr('href',path[2]);
      }
      var speed =   500,
          href =    $(this).attr('href'),
          $target = $(href == '#pagetop' || href == '#top' ? 'html' : href ),
          pos =     $target.offset().top;
          if(mq_small_up){
            var headerHeight = $('.l-header').height() + 20;
            pos = (pos - headerHeight);
          }
          if(mq_small_down){
            var headerHeight = 100;
            pos = (pos - headerHeight);
          }
      $('body,html').animate({scrollTop:pos},speed,'easeInOutExpo');
      if(href!='#pagetop' && href!='#top')
        window.history.pushState(null, null, this.hash);
      return false;
    });

    // ハッシュURLでスクロール
    (function(_){
      if(_.hash != '' && !/^#\/(?:.+)?/.test(_.hash) ){
        var pos = $(_.hash).offset().top;
        if(mq_small_up){
          var headerHeight = $('.l-header').height() + 20;
          pos = (pos - headerHeight);
        }
        if(mq_small_down){
          var headerHeight = 100;
          pos = (pos - headerHeight);
        }
        _.$target.animate({'scrollTop':pos},200,'easeInOutExpo');
      }
    }({
      hash:l.hash,
      $target:$('body,html')
    }));

}